import { Collapse } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage'; 

import { Basket } from '../../Modules/Basket';
import { ReactComponent as Trash_img } from '../../assets/images/basket/trash.svg';
import empty from '../../assets/images/emptyImage.svg';
import { Util } from '../../common/util/util';
import { Icon } from '../../components';
import { useAppDispatch } from '../../hooks/redux';
import { useActions } from '../../hooks/useActions';
import { useBasket } from '../../hooks/useBasket';
import { useUser } from '../../hooks/useUser';
import QuantityButton from '../../ui/card/QuantityButton/QuantityButton';

import './Basket.sass';

// Корзина
export const BasketItems = () => {
  const dispatch = useAppDispatch();
  const [load, setLoad] = useState(false);
  const {
    setAddCardsId,
    setBasketCatalogItems,
    setOrderQuantity,
    setOrderSum,
  } = useActions();
  const { session_token, loggedIn } = useUser();
  //Выбрать все
  const [isAllChecked, setIsAllChecked] = useState(false);
  //Чекнутые id
  const [checkedIds, setCheckedIds] = useState([]);
  //Чекнутый id
  const [checkedId, setCheckedId] = useState([]);
  //Корзина
  const {
    items: basketItems,
    order_sum,
    order_quantity,
    cards_id: addToBasketIds,
  } = useBasket();
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');

  let order_sum_text = `${Util.convertKopecksToRub(order_sum)} ₽`;
  //redux берем из props, чтобы обновлялось
  let catalog_items = Util.clone(basketItems);
  //Сортируем по продавцу (группировка)
  let catalog_items_sort = catalog_items.sort(
    (a: any, b: any) => a.vendor.id - b.vendor.id
  );
  let vendor_id_cur = '';

  //Группировка
  let groups = [];
  let group = {
    vendor: null,
    group_items: [],
  };

  catalog_items_sort.forEach((item: any) => {
    if (vendor_id_cur != item.vendor.id) {
      //Другой продавец

      //Скидываем предыдущий набор
      if (group.vendor != null) {
        groups.push(group);

        //Обнуляем
        group = {
          vendor: null,
          group_items: [],
        };
      }

      group.vendor = item.vendor;
      //Набираем в группу товары
      // @ts-ignore
      group.group_items.push(item);

      vendor_id_cur = item.vendor.id;
    } else {
      //Набираем в группу товары
      // @ts-ignore
      group.group_items.push(item);
    }
  });
  //Скидываем предыдущий набор
  if (group.vendor != null) {
    groups.push(group);

    //Обнуляем
    group = {
      vendor: null,
      group_items: [],
    };
  }

  const deleteItem = async (item_id: any) => {
    //Добавляем в Redux
    //Копируем текущий массив
    let catalog_items = Util.clone(basketItems);
    let ind = addToBasketIds.indexOf(item_id);
    // @ts-ignore
    await Basket.deleteItemFromBasket(catalog_items, item_id);
    let basket_info = Basket.getInfo(catalog_items);
    let copy_checkedIds = [...addToBasketIds];
    copy_checkedIds.splice(ind, 1);
    setAddCardsId(copy_checkedIds);
    /*Basket.saveToLocalStorageId(copy_checkedIds);*/
    //Сохраняем в LocalStorage
    Basket.saveToLocalStorage(catalog_items);
    //Сохраняем в Redux
    setBasketCatalogItems(catalog_items);
    setOrderSum(basket_info.order_sum);
    setOrderQuantity(basket_info.order_quantity);
    //Вызов синхронизации корзины с сервером, если залогинен
    if (loggedIn) {
      //Синхронизация при удалении товара в корзине
      await Basket.basketSynchronization(dispatch);
    }
  };

  //Удалить выбранные
  const deleteItems = async () => {
    //Добавляем в Redux
    //Копируем текущий массив
    if (loggedIn && checkedIds.length !== 0) {
      let catalog_items = Util.clone(basketItems);
      //Удалить из корзины
      for (const checkedID of checkedIds) {
        //Последовательно удаляем, хотя можно и параллеьно через await Promise.all и array.map, если не много элементов в корзине
        await Basket.deleteItemFromBasket(catalog_items, checkedID);
      }
      let basket_info = Basket.getInfo(catalog_items);
      if (isAllChecked) {
        setAddCardsId([]);
        /*Basket.saveToLocalStorageId([]);*/
      } else {
        let ind = addToBasketIds.indexOf(checkedId);

        let copy_checkedIds = [...addToBasketIds];
        copy_checkedIds.splice(ind, 1);
        setAddCardsId(copy_checkedIds);
        /*Basket.saveToLocalStorageId(copy_checkedIds);*/
      }
      //Сохраняем в LocalStorage
      Basket.saveToLocalStorage(catalog_items);
      //Сохраняем в Redux
      setBasketCatalogItems(catalog_items);
      setOrderSum(basket_info.order_sum);
      setOrderQuantity(basket_info.order_quantity);
      //Вызов синхронизации корзины с сервером, если залогинен
      //Синхронизация при удалении товара(ов) из корзины
      if (loggedIn) {
        await Basket.basketSynchronization(dispatch);
        setCheckedIds([]);
      }
    }
  };

  //Выбрать все
  const handleAllOnChange = (checked: any) => {
    setIsAllChecked(checked);
    if (checked) {
      //Добавляем в массив
      let ids: any = [];
      let items = basketItems;
      items.forEach((it: any) => ids.push(it.id));
      setCheckedIds(ids);
    } else {
      //Удаляем из массива
      setCheckedIds([]);
    }
  };

  //Чекнутая?
  const isChecked = (item_id: any) => {
    // @ts-ignore
    let ind = checkedIds.indexOf(item_id);
    return ind != -1 ? true : false;
  };

  //Чек
  const handleOnChange = (checked: any, item_id: any) => {
    // @ts-ignore
    let ind = checkedIds.indexOf(item_id);

    if (checked) {
      //Добавляем в массив
      if (ind == -1) {
        let copy_checkedIds = [...checkedIds];
        // @ts-ignore
        copy_checkedIds.push(item_id);
        setCheckedIds(copy_checkedIds);
        setCheckedId(item_id);
      }
    } else {
      //Удаляем из массива
      if (ind != -1) {
        let copy_checkedIds = [...checkedIds];
        copy_checkedIds.splice(ind, 1);
        setCheckedIds(copy_checkedIds);
        setCheckedId(item_id);
      }
    }
  };

  return groups.length >= 1 ? (
    <div className="BasketPage_div_left">
      {/*Галки*/}
      <div className="BasketPage_div_left_service">
        <div className="BasketPage_div_left_service_check_group">
          <input
            className="inp-cbx"
            id="basket_service_all"
            type="checkbox"
            style={{ display: 'none' }}
            checked={isAllChecked}
            onChange={(e) => handleAllOnChange(e.target.checked)}
          />
          <label className="cbx" htmlFor="basket_service_all">
            <span>
              <svg width="11px" height="8px" viewBox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
              </svg>
            </span>
            <span>Выбрать все</span>
          </label>
        </div>
        <button
          className="dazel-button-lite BasketPage_div_left_service_delete"
          onClick={() => deleteItems()}
        >
          <Trash_img /> Удалить выбранные
        </button>
      </div>
      <div className="BasketPage_div_left_group_bottom_wrapper">
        <div className="BasketPage_div_left_group_bottom_wrapper_scroll">
          {/*Товары*/}
          <TransitionGroup>
            {groups.map((gr: any, index) => (
              <Collapse key={`${gr.id}_${index}`}>
                <div
                  className="BasketPage_div_left_group"
                  key={`${index}_` + gr.id}
                >
                  <div className="BasketPage_div_left_group_top">
                    <Icon variant="shop" />
                    <span className="BasketPage_div_left_group_caption">
                      {gr.vendor.title}
                    </span>
                  </div>
                  <TransitionGroup className="BasketPage_div_left_group__container">
                    {gr.group_items.map((item: any, index: any) => (
                      <Collapse key={`${index}_${gr.id}`}>
                        <Fragment>
                          <div className="BasketPage_div_left_group_wrapper">
                            <input
                              className="inp-cbx"
                              id={'basket_check_' + item.id}
                              type="checkbox"
                              style={{ display: 'none' }}
                              checked={isChecked(item.id)}
                              onChange={(e) =>
                                handleOnChange(e.target.checked, item.id)
                              }
                            />
                            <label
                              className="cbx"
                              htmlFor={'basket_check_' + item.id}
                            >
                              <span>
                                <svg
                                  width="11px"
                                  height="8px"
                                  viewBox="0 0 12 10"
                                >
                                  <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                </svg>
                              </span>
                              <span></span>
                            </label>
                            <div className="BasketPage_div_left_group_item">
                              <div className="BasketPage_div_left_group_item__wrapper">
                                <Link
                                  to={`/items/${item.slug}`}
                                  className="BasketPage_div_left_group_item_img"
                                  onClick={() => {
                                    window.scrollTo({
                                      top: 0,
                                      behavior: 'auto',
                                    });
                                  }}
                                >
                                  <img src={item.img || empty} />
                                </Link>
                                <Link
                                  to={`/items/${item.slug}`}
                                  className="BasketPage_div_left_group_item_title"
                                  onClick={() => {
                                    window.scrollTo({
                                      top: 0,
                                      behavior: 'auto',
                                    });
                                  }}
                                >
                                  {item.title}
                                </Link>
                              </div>

                              <div className="BasketPage_div_left_group_item_right">
                                <div className="BasketPage_div_left_group_item_right_bottom">
                                  <div className="BasketPage_div_left_group_item_right_bottom_left">
                                    <div
                                      className="BasketPage_div_left_group_item_right_bottom_like"
                                      onClick={() => deleteItem(item.id)}
                                    >
                                      <Icon variant="trashCanGray" />
                                    </div>
                                  </div>
                                  <QuantityButton item={item} />
                                  {/*<div className="BasketPage_div_left_group_item_count_group">
                            <button
                              className="dazel-button-lite BasketPage_div_left_group_item_count_group_minus_btn"
                              onClick={() => minusItem(item.id)}
                            >
                              <Minus_img />
                            </button>
                            <span className="BasketPage_div_left_group_item_count_group_text">
                              {item.quantity}
                            </span>
                            <button
                              className="dazel-button-lite BasketPage_div_left_group_item_count_group_plus_btn"
                              onClick={() => plusItem(item.id)}
                            >
                              <Plus_img />
                            </button>
                          </div>*/}
                                </div>
                                <span className="BasketPage_div_left_group_item_price">{`${
                                  (item.price_kopecks * item.quantity) / 100
                                } `}</span>
                                <span className="BasketPage_div_left_group_item_price_currency">
                                  ₽
                                </span>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      </Collapse>
                    ))}
                  </TransitionGroup>
                </div>{' '}
              </Collapse>
            ))}
          </TransitionGroup>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
